/* eslint-disable hubspot-dev/no-private-classes */
import { Children, isValidElement } from 'react';
import { DialogProps } from '..';

/**
 * @see https://git.hubteam.com/HubSpot/UIComponents/blob/463f8aa756b2f9925aa5892cd438c8190ddb0a2b/UIComponents/static/js/dialog/DialogConstants.ts#L1-L6
 */
export const SIZE_CLASSES = {
  auto: '',
  medium: 'private-modal--medium',
  short: 'private-modal--short',
  tall: 'private-modal--tall',
};

/**
 * @see https://git.hubteam.com/HubSpot/UIComponents/blob/463f8aa756b2f9925aa5892cd438c8190ddb0a2b/UIComponents/static/js/dialog/DialogConstants.ts#L8-L22
 */
export const BACKWARDS_COMPATIBILITY_CLASSES = {
  default: 'private-modal--default private-modal--is-popup',
  conversational: 'private-modal--conversational private-modal--is-popup',
  info: 'private-modal--info private-modal--is-popup',
  success: 'private-modal--success private-modal--is-popup',
  danger: 'private-modal--danger private-modal--is-popup',
  fullscreen: 'private-modal--fullscreen',
  lightbox: 'private-modal--lightbox',
  sidebar: 'private-modal--sidebar',
  upgrades: 'private-modal--upgrades private-modal--is-popup',
};

/**
 * Returns true if every child element is a legacy component (e.g. UIDialogHeader, UIDialogBody, etc.) or false otherwise.
 */
function isEveryChildLegacyComponent(
  children: DialogProps['children']
): boolean {
  try {
    return Children.toArray(children).every((child) => {
      if (!isValidElement(child)) {
        return false;
      }
      const displayName = (child.type as any).displayName;
      return displayName && displayName.startsWith('UI');
    });
  } catch (ex) {
    return false;
  }
}

/**
 * Returns the same classes used by UIDialog and UIModal wrappers to ensure legacy children
 * components like UIDialogHeader, UIDialogBody, UIDialogFooter, etc. are styled correctly
 * but only if every child element is a legacy component.
 */
export function getBackwardsCompatibilityClasses(
  use: NonNullable<DialogProps['use']>,
  size: NonNullable<DialogProps['size']>,
  children: DialogProps['children']
): string {
  if (!isEveryChildLegacyComponent(children)) {
    return '';
  }

  return [
    'private-modal',
    BACKWARDS_COMPATIBILITY_CLASSES[use],
    SIZE_CLASSES[size],
  ]
    .filter(Boolean) // filter out extra space when size=auto
    .join(' ');
}
